module.exports = __webpack_public_path__ + "img/load-fail.8b4c38b5.png";